(function() { window.GUID_f9787973_3808_4696_a045_86c1748a0ce3 = { getGuid: function() { return "f9787973-3808-4696-a045-86c1748a0ce3"; } }; })();
let cookieName = "CompuSportCookie";
function GetCookieElement(sportEventId, array) {
    let actualCookie = $.cookie(cookieName);
    if (typeof (actualCookie) === 'undefined') {
        return;
    }
    if (array == null) {
        array = JSON.parse(actualCookie);
    }
    let existingElement = null;
    if (array != null) {
        $.each(array, function (index, element) {
            if (element.SportEventId == sportEventId) {
                existingElement = element;
            }
        });
        if (existingElement != null) {
            return existingElement;
        }
    }
    return { SportEventId: sportEventId, Values: "" };
}
//Seul les 2 premiers parametres doivent être passé, "element" sert pour le setCookie
function GetCookieValue(sportEventId, key, element) {
    key = key + '.' + CSParameters.Language;
    if (element == null) {
        element = GetCookieElement(sportEventId);
    }
    if (element == null) {
        return null;
    }
    let indexStart = element.Values.indexOf("<" + key + ">") + ("<" + key + ">").length;
    let indexEnd = element.Values.indexOf("</" + key + ">");
    if (indexEnd > -1) {
        var actualValue = element.Values.slice(indexStart, indexEnd);
        return actualValue;
    }
    return null;
}
function SetCookieValue(sportEventId, key, value) {
    key = key + '.' + CSParameters.Language;
    let array = [];
    let actualCookie = $.cookie(cookieName);
    let actualElement = {
        SportEventId: undefined,
        Values: undefined
    };
    if (typeof (actualCookie) !== 'undefined') {
        array = JSON.parse(actualCookie);
        actualElement = GetCookieElement(sportEventId, array);
        var actualValue = GetCookieValue(sportEventId, key.replace('.' + CSParameters.Language, ''), actualElement);
        var actualValueWithTag = "<" + key + ">" + actualValue + "</" + key + ">";
        var newValueWithTag = "<" + key + ">" + value + "</" + key + ">";
        if (actualElement.Values.indexOf(actualValueWithTag) > -1) {
            actualElement.Values = actualElement.Values.replace(actualValueWithTag, newValueWithTag);
        }
        else {
            actualElement.Values += newValueWithTag;
        }
    }
    let newArray = [];
    let actualElementAdded = false;
    if (array != null && array.length > 0) {
        $.each(array, function (index, element) {
            if (element.SportEventId == sportEventId) {
                newArray.push(actualElement);
                actualElementAdded = true;
            }
            else {
                newArray.push(element);
            }
        });
    }
    if (!actualElementAdded) {
        actualElement = {
            SportEventId: undefined,
            Values: undefined
        };
        actualElement.SportEventId = sportEventId;
        actualElement.Values = "<" + key + ">" + value + "</" + key + ">";
        newArray.push(actualElement);
    }
    $.removeCookie(cookieName);
    $.cookie(cookieName, JSON.stringify(newArray), { expires: 365, path: '/' });
}

//# sourceMappingURL=cs.cookie.js.map
